import React from "react";
import styles from './FJSearchHistory.module.less';
import FJLocalStore from "../../../../../store/FJLocalStore";
import FJButton from "fj-components/FJButton";
import FJIconButton from "../../../../../common/component/button-icon/FJIconButton";
import DeleteIcon from '../../../../../icon/delete-transition.svg';
import InlineSVG from "react-inlinesvg";
import classNames from 'classnames';

function FJSearchHistory(props){
  const {lists=[], active, onClear=() => {}} = props;

  const _onSubmit = (value) => {
		props.onSubmit(value)
	}

	const _onClear = (e) => {
  	e.stopPropagation();
		onClear();
	}

  return (
    <div className={classNames(styles.history_container, {[styles.active]: active})} onMouseDown={(e) => {e.preventDefault();}}>
      <div className={styles.history_info}>
        <span className={styles.history_title}>{FJLocalStore._('search history')}</span>
        <FJIconButton onClick={_onClear} className={styles.c_history_delete} icon={<InlineSVG src={DeleteIcon} />}/>
      </div>
      <div className={styles.history_list}>
        {
          lists.map((item) => {
            return (
              <FJButton text={item}
												key={item}
												className={styles.btn_class}
												textClass={styles.text}
												onClick={(e) => {
													e.stopPropagation();
													_onSubmit(item)
												}}
							/>
            )
          })
        }
      </div>
    </div>
  );
}

export default FJSearchHistory;